import React, {FC} from 'react';
import cx from 'classnames';
import Box from '@material-ui/core/Box';

import useLocalization from '../../../../../../hooks/useLocalization';
import MyTop10GamesPanelTrend from '../../../../../sidebar/my-top-10-games/MyTop10GamesPanelTrend';
import ColorSwatchDot from '../../components/ColorSwatchDot';
import {getDateline} from '../../../../../../components/global-date-picker/utils';
import {getIsLast24Hours} from '../../utils';
import {ActivationData} from '../../../../../../types';
import {DateMoment} from '../../../../../../types/Date';

import useStyles from './ListTooltip.styles';

const CODES = {
    preselectedDateRange: 'epic.affiliate.fortnite_games.xp.date_range.preselected_tooltip'
};

export interface ListTooltipProps extends ActivationData {
    formattedActivations: string;
    trend: number;
    colorIndex: number;
}

const ListTooltip: FC<ListTooltipProps> = ({
    startDate,
    endDate,
    name,
    description,
    formattedActivations,
    trend,
    colorIndex
}: ListTooltipProps) => {
    const style = useStyles();
    const getMessage = useLocalization();

    const dateline = (startDate: DateMoment, endDate: DateMoment) =>
        getIsLast24Hours({startDate, endDate, selectedDate: endDate})
            ? getMessage(CODES.preselectedDateRange)
            : getDateline({startDate, endDate});

    return (
        <div className={cx(style.activationTooltip, style.activationTooltipAnimation)}>
            <Box className={style.activationTooltipDate}>{dateline(startDate, endDate)}</Box>
            <Box className={style.activationTooltipNumbers}>
                {formattedActivations}
                <MyTop10GamesPanelTrend value={trend} />
            </Box>
            <Box className={style.activationTooltipText}>
                <ColorSwatchDot
                    cssClass={style.activationTooltipColorDot}
                    height="0.5rem"
                    width="0.5rem"
                    colorIndex={colorIndex}
                />
                <Box className={style.activationTooltipAccolade}>{name}</Box>
                <Box className={style.activationTooltipDescription}>{description}</Box>
            </Box>
        </div>
    );
};

export default ListTooltip;
